import { render, staticRenderFns } from "./ui-icon.vue?vue&type=template&id=6edb81a8&scoped=true&"
import script from "./ui-icon.vue?vue&type=script&lang=js&"
export * from "./ui-icon.vue?vue&type=script&lang=js&"
import style0 from "./ui-icon.vue?vue&type=style&index=0&id=6edb81a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edb81a8",
  null
  
)

export default component.exports